import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import { primerMayuscula } from "../helper";

const ContenedorResumen = styled.div`
    padding: 1rem;
    text-align: center;
    background-color: #00838f;
    color: #FFF;
    margin-top: 1rem;
    border-radius: .5rem;
`;

const Resumen = ({datos}) => {

    const {marca, year, plan} = datos;

    if (marca === '' || year === '' || plan === '') return null;

    return ( 
        <ContenedorResumen>
            <h2>Resumen de Cotización</h2>
            <ul>
                <li>Marca: {primerMayuscula(marca)}</li>
                <li>Plan: {primerMayuscula(plan)}</li>
                <li>Año del Auto: {year} </li>
            </ul>

        </ContenedorResumen>
        
    );
}

Resumen.propTypes = {
    datos: PropTypes.object.isRequired
}

export default Resumen;